import { RiCheckLine } from "@remixicon/react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Portal } from "@radix-ui/react-tooltip";

interface SelectAdProps {
  isSelected: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const SelectAd = ({ isSelected, onToggle, disabled = false }: SelectAdProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled) {
                onToggle();
              }
            }}
            disabled={disabled}
            className={cn(
              "h-[30px] min-w-[80px] flex items-center gap-[8px] p-[9px] squircle-mask squircle-smooth-[1] squircle-radius-[8px] pointer-events-auto backdrop-blur-sm cursor-pointer rounded-[8px] transition-colors",
              isSelected
                ? "bg-[#FF6C36] text-white"
                : "bg-[#00000099] hover:bg-[#000000CC] text-white",
              disabled && "opacity-50 cursor-not-allowed",
            )}
          >
            {isSelected ? (
              <RiCheckLine size={14} className="shrink-0" />
            ) : (
              <div className="w-[12px] h-[12px] squircle squircle-radius-[4px] squircle-smooth-[1] squircle-outline-[1px] squircle-outline-color-[#FFFFFF]"></div>
            )}
            <span className="mt-[2px] text-[12px] font-normal leading-[20px] tracking-[0.24px]">
              {isSelected ? "Selected" : "Select"}
            </span>
          </button>
        </TooltipTrigger>
        <Portal>
          <TooltipContent side="bottom" align="start">
            <p>
              {isSelected ? (
                "Remove selection"
              ) : (
                <>
                  Select multiple static images as examples,
                  <br />
                  then write a prompt to generate a new ad.
                </>
              )}
            </p>
          </TooltipContent>
        </Portal>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SelectAd;
